import { alerts, constants } from '@/constants'
import { RootState } from '@/reducers/store'
import {
    useUpdateActions,
    useUpdateAlerts,
} from '@/state/survey/poaSurveySlice'
import { Utility } from '@/utils'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
    Alert,
    IActionItem,
    INode,
    Ioption,
} from '../survey/SurveyModel/types/nodeTypes'

const withAlerts = (WrappedComponent: React.ComponentType<any>) => {
    return (props: any) => {
        const { node, name, disabled = false } = props
        const form = useSelector((state: RootState) => state.form)
        const { addNewAlert, removeAlertByName } = useUpdateAlerts()
        const { addNewAction, removeActionByName } = useUpdateActions()
        // const { addSectionWithActionsByName, removeSectionWithActionsByName } = useUpdateSectionsWithActions()

        const { actions } = useSelector((state: RootState) => state.poaSurvey)

        const processAlerts = (node: INode) => {
            if (node.alerts?.length) {
                node.alerts.forEach((alert: Alert) => {
                    if (
                        Utility.evaluateManually(form, alert.expression)
                    ) {
                        addNewAlert(node.name, alert.tag)
                    } else {
                        removeAlertByName(node.name, alert.tag)
                    }
                })
            }
            // REFACTOR NEEDED
            if (node.type === constants.Actions) {
                let actionsAvailable: Alert | undefined = undefined
                let expname = ''
                let actionNode: INode | null = null
                let actionNodeOptions: string[] = []
                const repeatWithinActons = (repeatedNode: INode) => {
                    if (repeatedNode.alerts?.length) {
                        actionsAvailable = repeatedNode.alerts.find(
                            (alert: Alert) => alert.type === alerts.action
                        ) as Alert | undefined
                        const regex = /{(.*?)}/g
                        if (actionsAvailable && actionsAvailable.expression) {
                            const matches =
                                actionsAvailable.expression.match(regex)
                            matches?.forEach((element: string) => {
                                expname = element.replace(/[{}]/g, '') // You may want to store all matches instead of just the last one
                            })
                        }

                        actionNode = repeatedNode
                        if (actionNode.options)
                            actionNodeOptions = (
                                actionNode.options as Ioption[]
                            ).map((item) => item.name)
                    }
                    if (repeatedNode.nodes?.length) {
                        repeatedNode.nodes.forEach((childNode: INode) =>
                            repeatWithinActons(childNode)
                        )
                    }
                }

                if (node.repeatedNodes) {
                    node.repeatedNodes.forEach((repeatedNode: INode) =>
                        repeatWithinActons(repeatedNode)
                    )
                }

                if (actionsAvailable) {
                    const rawValue = form[node.name]?.value as string
                    const activeActions: IActionItem[] = []
                    if (rawValue) {
                        try {
                            const actionValues = JSON.parse(rawValue)

                            if (
                                Array.isArray(actionValues) &&
                                actionValues.length &&
                                actionNode
                            ) {
                                actionValues.forEach((actions: any, i: number) => {
                                    let actionName: string = ''
                                    let actionValid: boolean = false
                                    actions.forEach((action: any) => {
                                        if (action.name === actionNode?.name) {
                                            actionName = action?.value
                                        }
                                        if (
                                            action.name === expname &&
                                            (!action.value ||
                                                action.value === 'false')
                                        ) {
                                            actionValid = true
                                        }
                                    })
                                    if (actionName) {
                                        // workaround to get the correct node name for the action, since the node name here dosent contain the node hash we need to check the dom to
                                        // get the correct node hash
                                        const nodeNamePattern = `${actionNode?.name || node.name}-node-`
                                        const matchingFormKey = Array.from(document.querySelectorAll(`[id^="${nodeNamePattern}"]`))[i]?.id;
                                        
                                        const actionStatus: IActionItem = {
                                            id: actionName,
                                            name: actionName,
                                            type: actionValid,
                                            nodeName: matchingFormKey || node.name,
                                        }
                                        addNewAction(actionStatus)
                                        activeActions.push(actionStatus)
                                    }
                                })
                            }
                        } catch (error) {
                            console.error(
                                'Invalid JSON in form value:',
                                error,
                                rawValue
                            )
                        }
                    } else {
                        console.warn(
                            `Value is empty or undefined for ${node.name}`
                        )
                    }

                    const removables: string[] = actionNodeOptions.filter(
                        (item) =>
                            !activeActions.some(
                                (activeItem) => activeItem.name === item
                            )
                    )

                    if (removables.length) {
                        removables.forEach((item: string) => {
                            if (
                                actions.some(
                                    (actionItem) => actionItem.name === item
                                )
                            )
                                removeActionByName(item)
                        })
                    }
                }
            } else {
                if (node.nodes?.length) {
                    node.nodes.forEach((childNode: INode) =>
                        processAlerts(childNode)
                    )
                }
            }
        }

        useEffect(() => {
            processAlerts(node)
        }, [form])

        return (
            <>
                <WrappedComponent
                    {...props}
                    disabled={
                        Object.prototype.hasOwnProperty.call(node, 'disabled') &&
                        node.disabled
                            ? node.disabled
                            : disabled
                    }
                    key={name}
                    className={node.type}
                    node={node}
                    name={name}
                />
            </>
        )
    }
}

export default withAlerts
